import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { DocumentDownloadIcon, QuestionMarkCircleIcon, SearchIcon } from '@heroicons/react/solid';
import { convert, formatDate, DisplayTime } from '../../utils/convertDate';
import { FormatMoney } from '../../utils/formatMoney';
import GeneralTable from '../../components/GeneralTable';
import { useNavigate } from 'react-router-dom';
import FGBondsServices from '../../services/fgbondsService';
import { toast } from 'react-toastify';
import Modal from '../../components/Modals/Modal';


const oldFrom = new Date().setDate(new Date().getDate() - 7);
const defaultTo = formatDate(new Date());
const longNew = formatDate(defaultTo);
const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
const longDate = formatDate(defaultFrom);

const FGNBondsListings = () => {
    const navigate = useNavigate()
    
    const [searchTreasuryBills, setSearchTreasuryBills] = useState("")
    const [too, setToo] = useState(convert(longNew));
    const [fromm, setFromm] = useState(convert(longDate));
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    });
    const [selectedStatus, setSelectedStatus] = useState(''); // New state for status filter
    const [adminType, setAdminType] = useState("");

    // State for pagination
  const [pageIndex, setPageIndex] = useState(1);
  const itemsPerPage = 10; // Adjust as needed

  // New state for treasury bill listings
  const [listings, setListings] = useState([]);
  const [totalListingsCount, setTotalListingsCount] = useState(0);
  const [totalPagesCount, setTotalPagesCount] = useState(0);

  // State for deactivation confirmation modal
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const [itemToDeactivate, setItemToDeactivate] = useState(null);

  
  useEffect(() => {
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  }, [])
  // Pagination handlers
  const prevPage = () => {
    if (pageIndex > 1) setPageIndex(pageIndex - 1);
  };

  const nextPage = () => {
    if (pageIndex < totalPagesCount) setPageIndex(pageIndex + 1);
  }

  // Define columns
  const columns = [
    { key: 'fgnBondName', header: 'FGN Bond Name' },
    { key: 'fgnBondID', header: 'FGN Bond ID' },
    { key: 'volume', header: 'Volume', render: (item) => FormatMoney(item.volume, 'NGN') },
    { key: 'tenor', header: 'Tenor' },
    { key: 'coupon', header: 'Coupon' },
    { key: 'firstCouponPaymentDate', header: 'First Coupon Payment Date', render: (item) => convert(item.firstCouponPaymentDate) },
    { key: 'secondCouponPaymentDate', header: 'Second Coupon Payment Date', render: (item) => convert(item.secondCouponPaymentDate) },
    { key: 'cleanPrice', header: 'Clean Price' },
    { key: 'maturityDate', header: 'Maturity Date', render: (item) => convert(item.maturityDate) },
    { key: 'redemptionValue', header: 'Redemption Value', render: (item) => FormatMoney(item.redemptionValue, 'NGN') },
    { key: 'status', header: 'Status', render: (item) => {
      const status = item?.status?.toLowerCase() || '';
      const statusColors = {
        'initiated': 'text-blue-500 font-semibold',
        'approved': 'text-green-500 font-semibold',
        'pending': 'text-yellow-500 font-semibold',
        'rejected': 'text-red-500 font-semibold'
      };
      const colorClass = statusColors[status] || 'text-gray-500 font-semibold';
      return <span className={colorClass}>{item.status || '-'}</span>;
    }},
    { key: 'createdBy', header: 'Created By' },
    { key: 'dateCreated', header: 'Date Created', render: (item) => convert(item.dateCreated) },
    { key: 'timeCreated', header: 'Time Created', render: (item) => DisplayTime(item.dateCreated) }
  ];

  const GetListings = async (
    page, 
    pageSize, 
    search, 
    startDate, 
    endDate, 
    status
  ) => {
    try {
        const response = await FGBondsServices.ListOfFGBonds(
            page, 
            pageSize, 
            search, 
            startDate, 
            endDate, 
            status,
        );
        setListings(response.data.result);
        setTotalListingsCount(response.data.totalCount);
        setTotalPagesCount(Math.ceil(response.data.totalCount / itemsPerPage));
    } catch (error) {
        console.error("Error fetching treasury bills:", error);
        setListings([]);
        setTotalListingsCount(0);
        setTotalPagesCount(0);
    }
}
  useEffect(() => {
    
    GetListings(
        pageIndex, 
        itemsPerPage, 
        "", 
        fromm, 
        too, 
        selectedStatus
    );
  }, [pageIndex, itemsPerPage, fromm, too, selectedStatus])

    const range = async (e) => {
        e.preventDefault();
        GetListings(
            pageIndex, 
            itemsPerPage, 
            searchTreasuryBills, 
            fromm, 
            too, 
            selectedStatus,
        );
    }

    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event });
            setFromm(formatDate(event));
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event });
            setToo(formatDate(event));
        }
    };

    const exportCSV = async () => {
         const resp = await FGBondsServices.exportFGBonds(searchTreasuryBills, fromm, too, selectedStatus);
         if(resp){
            window.open(resp.data)
         }
    }

    // Define actions - function that returns actions based on item status
    const getActions = (item) => {
      const baseActions = adminType.toLowerCase() === "checker" 
        ? ['View Bond', 'Deactivate Bond'] 
        : ['View Bond', 'Edit Bond', 'Deactivate Bond'];
      
      // Don't show deactivate action if status is Initiated or Rejected
      const status = item?.status?.toLowerCase();
      if (status === 'initiated' || status === 'rejected') {
        return baseActions.filter(action => action !== 'Deactivate Bond');
      }
      
      return baseActions;
    };

  // Handle action selection
  const handleActionSelect = async (action, item) => {
    // Add logic here to process the action (e.g., API call, state update)
    if(action === "View Bond"){
        navigate(`/fgn_bonds/view?${item?.id}`)
    }
    if(action === "Edit Bond"){
        navigate(`/fgn_bonds/edit?${item?.id}`)
    }
    if(action === "Deactivate Bond"){
        setItemToDeactivate(item);
        setIsDeactivateModalOpen(true);
    }
  };

  // Handle deactivation confirmation
  const handleDeactivateConfirm = async () => {
    if (itemToDeactivate) {
        const response = await FGBondsServices.deactivateBooking(itemToDeactivate.id)
        if(response){
            toast.success(response.message)
            setIsDeactivateModalOpen(false);
            setItemToDeactivate(null);
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    }
  };

  // Handle deactivation cancellation
  const handleDeactivateCancel = () => {
    setIsDeactivateModalOpen(false);
    setItemToDeactivate(null);
  };
  
    return (
        <Layout title="FGN Bonds" pageTag={"fgn_bonds"} current={'/fgn-bonds'}>
            <React.Fragment>
                <main className='mt-5'>
                    <div className="sm:flex items-center flex-wrap">
                        <div className="sm:flex-auto flex items-center flex-wrap">

                            <div className=" relative rounded-md shadow-sm ">
                                <p className='text-sm leading-3 text-gray-500'>From</p>
                                <div>
                                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                </div>
                            </div>
                            <div className=" relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>To</p>
                                <div>
                                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                </div>
                            </div>
                            <div className=" relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>Status</p>
                                <div>
                                    <select
                                        id="statusFilter"
                                        name="statusFilter"
                                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                        value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.target.value)}
                                    >
                                        <option value="">None</option>
                                        <option value="Initiated">Initiated</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Approved">Approved</option>
                                        <option value="Rejected">Rejected</option>
                                    </select>
                                </div>
                            </div>
                            <div className='flex ml-4'>
                                <div className="mt-5 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        name="fgnBonds"
                                        id="fgnBonds"
                                        onChange={(e) => setSearchTreasuryBills(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search FGN Bonds"
                                    />
                                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext"> <p>Search FGN Bonds</p></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className='mt-5 ml-4'>
                                <button
                                    onClick={range}
                                    className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                            </div>
                        </div>

                        <div className="flex items-center mt-3">
                            <button onClick={() => navigate("/fgn_bonds/create")} className="inline-flex mr-2 items-center text-white active:text-white justify-center rounded-md border border-transparent bg-red-600 px-2 py-2 text-sm font-medium shadow-sm  sm:w-auto">
                                Create FGN Bonds
                            </button>
                            <button
                                type="button"
                                onClick={exportCSV}
                                className="inline-flex mr-2 items-center hover:text-white active:text-white justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm  sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                        </div>
                    </div>

                    {/* table */}
                    <GeneralTable
                        columns={columns}
                        data={listings}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        totalCount={totalListingsCount}
                        totalPages={totalPagesCount}
                        prevPage={prevPage}
                        setPageIndex={setPageIndex}
                        actions={getActions}
        onActionSelect={handleActionSelect}
                    />

                    {/* Deactivation Confirmation Modal */}
                    <Modal
                        isOpen={isDeactivateModalOpen}
                        onClose={handleDeactivateCancel}
                        onConfirm={handleDeactivateConfirm}
                        onCancel={handleDeactivateCancel}
                        modalTitle="Deactivate FGN Bond"
                        modalText={`Are you sure you want to deactivate this FGN Bond (${itemToDeactivate?.fgnBondName || itemToDeactivate?.fgnBondID})? This action may affect related transactions.`}
                    />
                </main>

            </React.Fragment>
        </Layout>
    )
}

export default FGNBondsListings